<template>
    <div class="home">
        <Nav/>
        <div class="banner-img">
            <img src="../assets/07.png"/>
        </div>
        <div class="main">
            <div class="pro-info">
                <div>
                    <h3>产品描述</h3>
                    <div class="mt25">借款人将其或其配偶名下房产抵押给我司的贷款产品。</div>
                </div>
                <div>
                    <h3>申贷条件</h3>
                    <div class="mt25">个人名下住宅、房改房、经适房、拆迁房等可上市流通的住宅（不同类型房屋房产政策，非住宅抵押业务一事一议）。</div>
                </div>
                <div>
                    <h3>申贷流程</h3>
                    <div class="mt25">① 客户申请。客户向机构提出申请，书面填写申请表，同时提交相关资料。</div>

                    <div>② 签订合同。对借款人提交的申请资料审核通过后，双方签订借款合同、担保合同。</div>

                    <div>③ 发放贷款。取得抵押凭证后，经审批同意发放贷款的，办妥所有手续后，按合同约定以转账方式直接划入借款人的交易对象或发放给借款人。</div>

                    <div> ④ 贷后检查。对借款人执行借款合同情况及借款人经营情况进行追踪调查和检查。</div>

                    <div>⑤ 按期还款。借款人按借款合同约定的还款计划、还款方式偿还贷款本息。</div>

                    <div>⑥ 贷款结清。贷款结清包括正常结清和提前结清两种。</div>
                </div>
                <div>
                    <h3>所需材料</h3>
                    <div class="mt25">① 银行流水（如有）身份证明：借款人及共借人身份证、户口本</div>
                    <div>② 婚姻证明：借款人及共借人婚姻证明</div>
                    <div>已婚：结婚证</div>
                    <div>离异：离婚证及离婚协议或法院判决书或法院调解书</div>
                    <div>丧偶：死亡证明或销户证明</div>
                    <div> ③ 征信证明：借款人及共借人央行征信</div>

                    <div>④ 房产证明：抵押房产房产证、备用房房产证（如有）</div>

                    <div> ⑤ 评估证明：官方评估报告、互联网参考价截屏、现场询价</div>

                    <div> ⑥ 下户照片</div>

                    <div> ⑦ 租赁证明：租赁合同、承租人声明</div>

                    <div> ⑧ 三方信息：人法、失信网查询截图</div>

                    <div> ⑨ 风控审批报告</div>

                    <div> ⑩ 银行流水（如有）</div>

                    <div> ⑪ 客户借款申请表（如有）</div>

                    <div> ⑫ 工作证明（如有）</div>

                    <div> ⑬ 特殊资料（拆迁协议、上市确认书、购房合同等）</div>

                </div>
                <div>
                    <h3>贷款费用</h3>
                    <div class="mt25">年化10.5%~18%</div>
                </div>
                <div>
                    <h3>还款和计息方式</h3>
                    <div class="mt25">按月付息、到期还本、等额本息还款</div>
                </div>
                <div>
                    <h3>逾期处理方式</h3>
                    <div class="mt25">逾期罚息：每日按贷款金额为基础收取罚息，罚息年化利率为24%</div>
                </div>
                <div>
                    <h3>业务投诉电话</h3>
                    <div class="mt25">4008-830-822</div>
                </div>
            </div>
            <Foot class="mt100"/>
        </div>
    </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {},
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .home {
        .banner-img {
            img {
                width: 100%;
            }
        }
        .main {
            height: 729px;
            padding-bottom: 100px;
            .pro-info {
                position: relative;
                margin-left: 25%;
                .black-bl {
                    position: absolute;
                    top: -17px;
                    color: rgba(51, 47, 43, 1);
                    font-weight: 500;
                    font-size: 26px;
                }
                div {
                    font-size: 13px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(142, 142, 142, 1);
                    line-height: 26px;
                }
                .mt25 {
                    margin-top: 25px;
                }
                h3 {
                    padding-top: 70px;
                    font-size: 20px;
                    color: rgba(51, 47, 43, 1);
                }
                .mt40 {
                    margin-top: 40px;
                }
                .ml60 {
                    margin-left: 3.125%;
                }
            }
        }

    }

</style>
